
// src/web/components/file-upload-button.jsx

import React from 'react'
import ReactDOM from 'react-dom'
import {
  Button
} from 'react-toolbox/lib/button'

export default class FileUploadButton extends React.Component {
  onClick = ()=> ReactDOM.findDOMNode(this.refs.input).click()
  onChange = (e)=> {
    if (e.target.files.length > 0) {
      this.props.onChange(e.target.files)
      ReactDOM.findDOMNode(this.refs.input).value = ''
    }
  }

  render() {
    return <Button {...this.props} onClick={this.onClick}>
            <input type="file" style={{ display: 'none' }}
                    ref="input"
                    multiple={!this.props.single}
                    onChange={this.onChange} />
           </Button>
  }
}



// WEBPACK FOOTER //
// ./src/web/components/file-upload-button.jsx